import React from "react";
import "./Footer.css";

const Footer = props => (
  <div className="footer">
    <p className="center">{props.title} &copy;2019</p>
  </div>
);

export default Footer;
